import { getHomePagePerPermissions } from '~/utils/permissions-utils'
import { ROLES } from '~/utils/role-utils'
import { type User } from '~/utils/types/user'

const HOME_PATH_BY_ROLE: Partial<Record<User['role'], string>> = {
  [ROLES.FAMILY]: '/my-profile',
  [ROLES.FACILITATOR]: '/surveys',
  [ROLES.STAKEHOLDER]: '/solutions',
  [ROLES.SURVEY_TAKER]: '/surveys',
}

export function getAuthenticatedHomePath(
  user: Pick<User, 'permissions' | 'role'>,
): string {
  if (user.permissions?.length) {
    const permissionHomePage = getHomePagePerPermissions(user.permissions)
    if (permissionHomePage) return `/${permissionHomePage}`
  }

  return HOME_PATH_BY_ROLE[user.role] ?? '/homepage'
}
